// Where we send someone who wants the Ubik desktop app, and how we tell that
// page which installer to offer first.
//
// This lives in one place on purpose: the login page and the meetings page both
// link to the download, and past redirection failures came from each surface
// re-deriving its own platform detection and disagreeing about the ?os= hint.

// Stable download landing page. Takes an ?os= hint (added in buildDownloadUrl)
// so the page can offer the right installer first.
export const DOWNLOAD_PAGE_URL = "https://theubik.com/download";

// theubik.com/download takes an ?os= hint so the page can offer the right
// installer first. Default to mac when we can't detect the platform.
function platformParam(platform: string | null | undefined): "mac" | "windows" {
  if (platform && /win/i.test(platform)) return "windows";
  return "mac";
}

export function buildDownloadUrl(base: string, platform: string | null | undefined): string {
  const os = platformParam(platform);
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}os=${os}`;
}

export function browserPlatform(): string | null {
  return window.navigator.platform || window.navigator.userAgent || null;
}
